import React from 'react'

const Records = ({handleRecordClick}) => {
  return (
    <p className="mt-2">
              No. of Records{" "}
              <select className="px-2" onClick={handleRecordClick}>
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
              </select>
            </p>
  )
}

export default Records